<script setup>
import SideNav from '@/common/pageComponents/SideNav.vue';

import { useUserStore } from "@/stores/user";
import { computed, ref } from 'vue';
import zhCn from 'element-plus/dist/locale/zh-cn.mjs';
import zhEn from 'element-plus/dist/locale/en.mjs';


import { useRoute } from "vue-router";
// import { useMeta } from 'vue-meta';
let route = useRoute();

const store = useUserStore()
let isMobile = computed(()=>store.isMobile)
let sideNavConfig = computed(() => store.sideNavConfig)

// 产品详情页切换产品（仅 query.id 变化）时不重建整个页面，
// 由 ProductDetail1.vue 内部 watch(route.query) 局部刷新数据，避免整屏闪动
const viewKey = computed(() =>
  route.path === '/detail1' ? route.path : route.fullPath
)

</script>

<template>
    
    <el-config-provider :locale="useUserStore().language == 'zh-CN' ? zhCn : zhEn">
      
      <router-view :key="viewKey" />
    </el-config-provider>
    <SideNav v-if="!isMobile && sideNavConfig" :jumpUrl="sideNavConfig.mapUrl" :qrCode="sideNavConfig.qrCode"></SideNav>
</template>

<style>

</style>
